export default "__VITE_ASSET__BAu3YGi6__"